import React, { useState } from 'react'
import './Signup.css'

// Hooks
import { useSignUp } from '../../Hooks/useSignUp'

export default function Signup() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [thumbnail, setThumbnail] = useState(null)
  const [thumbnailError, setThumbnailError] = useState(null)

  const { signup, isPending, error } = useSignUp()

  // handle file 
  const handleFileChange = (e) => {
    setThumbnail(null)
    let selected = e.target.files[0]
    console.log(selected)
    if(!selected){
      setThumbnailError('File not selected')
      return
    }
    if(!selected.type.includes('image')){
      setThumbnailError('Selected file must be an image')
      return
    }
    if(selected.size > 10000000){
      setThumbnailError('Image file size must be less than 10Mb (10 Megabyte)')
      return
    }
    
    setThumbnailError(null)
    setThumbnail(selected)

    console.log('thumbnail set')
  }

  // handle  submit
  const handleSubmit = async (e) => {
    e.preventDefault()
    // console.log('Name: '+ displayName, "file: " + thumbnail, "Email: " + email, "Password: "+password)
    await signup(displayName, email, password, thumbnail)
    setDisplayName('')
    setEmail('')
    setPassword('')
    setThumbnail('')
  }

  return (
    <form className='auth-form' onSubmit={handleSubmit}>
      <h2>Sign up</h2>
      <label>
        <span>Name:</span>
        <input type="text" required value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
      </label>
      <label>
        <span>Profile Picture:</span>
        <input type="file"
         required  onChange={handleFileChange} 
        />
        { thumbnailError && <small>{thumbnailError}</small>}
      </label>
      <label>
        <span>Email:</span>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
      </label>
      <label>
        <span>Password:</span>
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
      </label>
      {!isPending && <button type='submit' className='btn'>Signup</button>}
      {isPending && <button  disabled className='btn'>Loading...</button>}
      { error && <div className="error">{error}</div> }
    </form>
  )
}
